import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { registerServiceWorker } from '@coeldery/pwa-spa';
import './i18n';
import './index.css';
import App from './App';

// PWA（P1.5-A；decisions/015 §2.5）：**只喺生產 build 註冊**。
// ⚠️ dev 唔註冊 —— 否則 service worker 會 cache 住舊 asset，令 HMR 鬼打牆。
// ⚠️ SW 只快取外殼：HTML 同 `/api/*` 一律 network-only（每次入 app 拎最新數）。
registerServiceWorker({ enabled: import.meta.env.PROD });

const root = document.getElementById('root');
if (!root) throw new Error('missing #root');

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
